import Image from "next/image";
import React from "react";
import {s3ImageSource} from "src/useS3ImgSrc";

/**
 * Renders the thumbnail for a location.
 */
const LocationThumbnail = ({
  imageId,
}: {
  /** The id for the locations cover image  */
  imageId: string;
}) => {
  return (
    <Image
      className="rounded-full"
      priority
      src={s3ImageSource(imageId)}
      height={56}
      width={56}
      alt=""
    />
  );
};

export default React.memo(LocationThumbnail);
